import React, { Component } from 'react';
import axios from 'axios';
import {path} from './routes.js';
import Modal from 'react-modal';
import CurrentASMEdit from './CurrentASMEdit.js'; //component that contains the information of prize/gift that is currently being edited
import loader from '../asset/img/loader.gif';

export default class EditASMPrize extends Component {
	constructor(props){
		super(props);
		this.editPrize = this.editPrize.bind(this);
		this.openModal = this.openModal.bind(this);
		this.closeModal = this.closeModal.bind(this);
		this.commitEdit = this.commitEdit.bind(this);
		this.updatePrize = this.updatePrize.bind(this);
		this.state = {currentEdit:'',editedPrizes:[],failed:false,modalIsOpen:false,modalPrompt:'',loading:false};
	}

	editPrize(e){	//method for selecting which prize/gift to be edited. passes down information to currentASMEdit component
		let ID = e.target.id;
		let prize;
		this.props.prizes.forEach((prizes)=>{
			if(Number(prizes.prizeID) === Number(ID)){
				prize = prizes;
			}
		});
		this.setState({currentEdit:prize},function(){
			this.openModal();
		});
	}

	updatePrize(p){ //method that handles api calls for updating all prize/gift information
		let calls = [];
		calls.push(axios({ //update information in LOV_Prizes table
			method:'post',
			url:path,headers:{'Content-Type':'application/json'},
			data:{endpoint:'create',table:'prizes',misc:'update',name:p.prize,secondID:p.tier,desc:p.description,firstID:p.ID,status:p.status}
		}));
		calls.push(axios({ //update information in LOV_ASM_Gift_Pricing table
			method:'post',
			url:path,headers:{'Content-Type':'application/json'},
			data:{endpoint:'create',table:'pricing',firstID:p.ID,cost:p.price,misc:'edit'}
		}));
		calls.push(axios({ //update information in LOV_ASM_Inventory  table
			method:'post',
			url:path,headers:{'Content-Type':'application/json'},
			data:{endpoint:'create',table:'inventory',misc:'update',firstID:p.ID,secondID:p.threshold,quantity:p.quantity}
		}));
		axios.all(calls).then(()=>{
			this.props.onClose(this.props.year);
			this.setState({modalPrompt:'Gift updated!'},function(){
				this.setState({loading:false});
			});
		}).catch(()=>{
			this.setState({loading:false});
			this.setState({modalPrompt:'A problem has occured. Please try again.'});
		});
	}

	commitEdit(edited){ //begin process of saving edited information
		this.setState({currentEdit:'',loading:true});
		this.updatePrize(edited);
	}

	openModal() { //open the modal
    	this.setState({modalIsOpen: true});
  }

	closeModal() { //close the modal
	    this.setState({modalIsOpen: false,modalPrompt:''});
	}

	render(){
		const customStyles = {
		  content : {
		    top: '50%',
		    left: '50%',
		    right: 'auto',
		    bottom: 'auto',
		    width:'100%',
		    maxWidth:'800px',
		    backgroundColor:'#F4F4F4',
		    borderStyle:'solid',
		    borderWidth:'2px',
		    borderColor:'gray',
		    paddingTop:'0',
		    transform: 'translate(-50%, -50%)',
		    boxShadow:'0.5px 0.5px 1px 0.5px'
			}, 
			overlay:{
				backgroundColor:'rgba(105,105,105,0.8)'
			}
		};
		const pStyles = "mt0 pt2 fl w-100 b navy mb3 bb b--light-silver";
		const picstyles= {display:'block', maxWidth:'100px',maxHeight:'122px',width:'auto',height:'auto',margin:'auto'};
		const buttonStyles = "bg-navy white br2 b pa1 tc"
		let prizes;
		let spanStyle;
		let divStyles;
		let modalContent;
		if(this.state.currentEdit !== ''){ //modal displays the CurrentASMEdit component
			modalContent =<div>
							<div className="fl w-100 tr pt2">
					        	<button className="bg-white gray b br3" onClick={this.closeModal}>X</button>
					        </div>
						 	<CurrentASMEdit prize={this.state.currentEdit} onFinish={this.commitEdit} tiers={this.props.tiers}/>
						 </div>;
		}else if(this.state.loading){ //display loading gif
			modalContent = <div className="tc" style={{width:'150px',margin:'auto'}}><img src={loader} alt="Loading" /></div>;
		}else{ //display message prompt
			modalContent = <div>
							<div className="fl w-100 tr pt2">
					        	<button className="bg-white gray b br3" onClick={this.closeModal}>X</button>
					        </div>
							<p className="b navy tc f4">{this.state.modalPrompt}</p>
							</div>;
		}
		prizes= this.props.prizes.map((prizes,i)=>{ //loop through and display all prizes/gifts
			if(prizes.quantity <= prizes.threshold){ //highlight prize if current inventory is lower than the set threshold in the LOV_ASM_Inventory table
					spanStyle = "red";
					divStyles = "pa2 ba br3 overflow-y-auto ma3 bg-white shadow-3 b--red";
				}else{
					spanStyle = "";
					divStyles = "pa2 ba br3 overflow-y-auto ma3 bg-white shadow-3 b--navy";
				}
			return(<div className="fl w-50-ns w-100-m w-100 mb2 pa1" key={i}><div style={{maxWidth:'460px',margin:'auto'}} className={divStyles} key={prizes.prizeID}>
								<div className="fl w-60 pr2" style={{minHeight:'200px',maxHeight:'200px'}}>
									<p className="mt0 pt2 tc b navy underline">{prizes.prize}</p>
									<img src={prizes.picture} alt="error" style={picstyles}/>
									<p className="tc navy">{prizes.description}</p>
								</div>
								<div className="fl w-40">
									<div className="fl w-100">
										<p className={pStyles}>Tier: {prizes.tier}</p>
										<p className={pStyles}>Price: ${prizes.price.toFixed(2)}</p>
										<p className={pStyles}>Quantity: <span className={spanStyle}>{prizes.quantity}</span></p>
										<p className={pStyles}>Status: {prizes.status}</p>
										<button id={prizes.prizeID} onClick={this.editPrize} className={buttonStyles}>Edit Prize</button>
									</div>
								</div>
							</div></div>);
			});
		return(
			<div>
				<div>
					{prizes}
				</div>
				<div>
					<Modal
		          isOpen={this.state.modalIsOpen}
		          style={customStyles}
		          contentLabel="shopping cart Modal"
		          shouldCloseOnOverlayClick={false}
		          shouldCloseOnEsc={false}
		        >
		        {modalContent}
				</Modal>
				</div>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/container/EditASMPrize.js